import { Controller } from '@hotwired/stimulus';

/**
 * Poll - reloads the surrounding Turbo Frame every few seconds while something is still in progress.
 * Put it on an element inside the frame: each reload swaps that element, so the controller reconnects
 * and reads the fresh `active` value; when the server says active=false the polling stops.
 * Values: interval (Number, ms, default 3000) | active (Boolean)
 * @example <turbo-frame id="import_1"><div data-controller="poll" data-poll-active-value="true">…</div></turbo-frame>
 */
export default class extends Controller {
  static values = { interval: { type: Number, default: 3000 }, active: Boolean };

  connect () {
    if (this.activeValue) this.timeout = setTimeout(() => this.reload(), this.intervalValue);
  }

  disconnect () {
    clearTimeout(this.timeout);
  }

  reload () {
    const frame = this.element.closest('turbo-frame');
    if (!frame) return;
    if (frame.src) {
      frame.reload();
    } else {
      frame.src = window.location.href;
    }
  }
}
